import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';

export default BaseOverride;
